import React, { useEffect, useState } from 'react';
import Encabezado from './Encabezado';
import { useAuth } from '../contextos/AuthProvider'
import { useNavigate } from 'react-router-dom';
import AgregarProd from './AgregarProd';
import TablaProductos from './TablaProductos';
import PieDelDocumento from './PieDelDocumento';
import Swal from 'sweetalert2';
import { EncabezadoPost, TiposDocsCrearDoc, EncApi, CodigosTarifasDiferenciadas } from '../Comunes/Listas';

const BaseDoc = () => {


    const { PerfilUsuario, Token } = useAuth();
    const [LasUnidadesMedida, setLasUnidadesMedida] = useState(null)
    const [Gestor, setGestor] = useState({
        //Datos Generales
        BDCompania: PerfilUsuario.BD,
        TipoDocumento: '1',
        Ambiente: PerfilUsuario.IdCia !== 1,
        Operacion: 'A',
        Docnum: 0,
        Docentry: 0,
        DocDate: '2025-01-01',
        Sucursal: PerfilUsuario.Sucursal,
        Terminal: 1,
        CodigoActividad: '',
        //Datos Cliente
        CodigoActividadReceptor: '',
        SN: 'N',
        NombreCliente: '',
        CedulaCliente: '',
        CorreoCliente: '',
        ConCopiaCliente: '',
        TipoIdentCliente: '',
        SenasCliente: '',
        ProvinciaCliente: '1',
        CantonCliente: '1',
        DistritoCliente: '1',

        DetalleLineas: [],
        CondicionVenta: '01',
        CondicionVentaText: '',
        PlazoCredito: '0',
        Vencimiento: '2025-01-01',
        MedioPago: [],
        ReferenciaCL: '',
        CodigoMoneda: 'CRC',
        Nota: '',
        TC: '',
        TotalSap: 0,
        TieneOtrosCargos: false,
        Cod_Vendedor: 0,
        Redondeo_Col: 0,
        Redondeo_Extr: 0,
        //Referencia
        TipoDocRef: '',
        NumeroRef: '',
        FechaEmisionRef: '2025-01-01',
        CodigoRef: '01',
        RazonRef: '',
        //Cadenas
        EnviaAutoMercado: false,
        NumeroVendedor: '',
        NumeroOrden: '',
        EnviarGLN: '',
        FechaOrden: '2025-01-01',
        NumeroRecepcion: '',
        EnviaWalmart: false,
        WMNumeroVendedor: '',
        WMNumeroOrden: '',
        WMEnviarGLN: '',
        WMFechaOrden: '2025-01-01',
        WMNumeroRecepcion: '',
        WMReclamo: '',
        WMFechaReclamo: '2025-01-01',
        WMNumeroReclamo: '',
        FreshOrden: '',
        FreshGLN: '',
        CargosAdicionales: [],
        TipoDocumentoOtrosCarg: '',
        DetalleOtrosCarg: '',
        MontoCargo: 0,
        cboTipoDocRef: '3',
        cboDocRef: '',
        ImpServ: 'N',
        CkDatosRef: 'N',
        ProductoAgregar: '',

        EsClienteExonerado: false,
        cboAplicaExonera: 'S',
        cboTipoDocExoneracion: '01',
        txtNumeroDocumentoExonera: '',
        txtNombreInstiExonera: '',
        cboPorcentajeExoneracion: '13',
        txtFechaEmisionExonera: '2025-01-01',
        Articulo: '0',
        Inciso: '0',
        DE_TASA_IMP: '08',

        //Medios de Pago
        Efectivo: '',
        Tarjeta: '',
        Cheque: '',
        Transferencia: '',
        Tercero: '',
        Sinpe: '',
        Plataforma: ''
    })
    const Modificar = async (e) => {
        const { name, value, type } = e.target;
        console.log(name);
        switch (name) {
            case 'ImpServ':
                setGestor({ ...Gestor, [name]: (Gestor.ImpServ === 'S') ? 'N' : 'S' });
                Totalizar('ck');
                break;
            case 'SN':
                setGestor({ ...Gestor, [name]: (Gestor.SN === 'S') ? 'N' : 'S' });
                break;
            case 'cboDocRef':
                setGestor({ ...Gestor, [name]: value });
                await Oriflar(Gestor.cboTipoDocRef, value);
                break;
            case "CkDatosRef":
                setGestor({ ...Gestor, [name]: (Gestor.CkDatosRef === 'S') ? 'N' : 'S', "TipoDocRef": (Gestor.CkDatosRef === '') ? '01' : '' });
                break;
            case "cboTipoDocRef":
            case "TipoDocumento":
                let posibles = ['3', '2', 'C', 'P', 'O', '10'];
                let Aux = ''
                const tipoDoc = name === 'TipoDocumento' ? value : Gestor.TipoDocumento;
                if (name === 'TipoDocumento') {
                    switch (tipoDoc) {
                        case '10':
                        case '3':
                            Aux = '1';
                            break;
                        case '2':
                            Aux = '3';
                            break;
                        case 'C':
                        case 'P':
                        case 'O':
                            Aux = 'N';
                            break;

                        default:
                            break;
                    }

                    setGestor({
                        ...Gestor,
                        [name]: value,
                        "cboTipoDocRef": Aux,
                        "SN": value === '1' ? 'N' : Gestor.SN,
                        "CkDatosRef": value === '8' ? 'S' : Gestor.CkDatosRef
                    });
                }
                else {
                    setGestor({ ...Gestor, [name]: value, "SN": value === '1' ? 'N' : Gestor.SN });
                    Aux = value;
                }
                if (posibles.includes(tipoDoc) && Aux !== 'N') {
                    CargaDocumentoReferenciados(tipoDoc, Aux);
                }
                else {
                    setDocumentosReferenciados([]);
                }

                break;
            default:
                setGestor({ ...Gestor, [name]: (type === 'number') ? parseInt(value) : value, "SN": value === '1' ? 'N' : Gestor.SN });
                break;
        }

        //console.log(props.EntidadActual);
    }
    const GuardarDocumento = () => {
        console.log(Gestor);
        if (!Gestor.DetalleLineas || Gestor.DetalleLineas.length === 0) {
            Swal.fire("Alerta", "Primero debe agregar al menos una línea  (Producto)", "error");
            return;
        }
        let sumaMedios = (parseFloat(Gestor.Efectivo) || 0) + (parseFloat(Gestor.Tarjeta) || 0) + (parseFloat(Gestor.Cheque) || 0) + (parseFloat(Gestor.Transferencia) || 0) + (parseFloat(Gestor.Tercero) || 0) + (parseFloat(Gestor.Sinpe) || 0) + (parseFloat(Gestor.Plataforma) || 0);
        console.log(Math.round(Gestor.TotalSap * 100) / 100);
        if ((sumaMedios !== (Math.round(Gestor.TotalSap * 100) / 100) && (!(Gestor.CondicionVenta === '02' || Gestor.CondicionVenta === '08' || Gestor.CondicionVenta === '10')))) {
            Swal.fire("Alerta", "El total de los medios de pago: " + ((parseFloat(Gestor.Efectivo) || 0) + (parseFloat(Gestor.Tarjeta) || 0) + (parseFloat(Gestor.Cheque) || 0) + (parseFloat(Gestor.Transferencia) || 0) + (parseFloat(Gestor.Tercero) || 0) + (parseFloat(Gestor.Sinpe) || 0) + (parseFloat(Gestor.Plataforma) || 0)) + "  no coincide con el total del documento: " + (parseFloat(Gestor.TotalSap.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))), "error");
            return;
        }

        if ((Gestor.CondicionVenta === '02' || Gestor.CondicionVenta === '10') && new Date(Gestor.Vencimiento) < new Date(Gestor.DocDate)) {
            Swal.fire("Alerta", "La fecha de vencimiento no puede ser anterior a la fecha del documento.", "error");
            return;
        }

        const mediosPago = [
            { TipoMedioPago: '01', TotalMedioPago: parseFloat(Gestor.Efectivo), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '02', TotalMedioPago: parseFloat(Gestor.Tarjeta), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '03', TotalMedioPago: parseFloat(Gestor.Cheque), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '04', TotalMedioPago: parseFloat(Gestor.Transferencia), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '05', TotalMedioPago: parseFloat(Gestor.Tercero), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '06', TotalMedioPago: parseFloat(Gestor.Sinpe), MedioPagoOtros: 'NA' },
            { TipoMedioPago: '07', TotalMedioPago: parseFloat(Gestor.Plataforma), MedioPagoOtros: 'NA' }
        ].filter(medio => medio.TotalMedioPago > 0);


        Swal.fire({
            title: '¿Está seguro de guardar el documento?',
            showCancelButton: true,
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            confirmButtonText: 'Sí, de acuerdo',
            cancelButtonText: 'Cancelar',
            preConfirm: async () => {

                let TipoDocRef = Gestor.TipoDocumento === '3' || Gestor.TipoDocumento === '2' || Gestor.TipoDocumento === '10' ? (Gestor.cboTipoDocRef.length === 1 ? '0' + Gestor.cboTipoDocRef : Gestor.cboTipoDocRef) : null;
                if (Gestor.CkDatosRef === 'S') {
                    TipoDocRef = Gestor.TipoDocRef || TipoDocRef; // Asegúrate de que no sea undefined o null
                }
                //console.log(TipoDocRef);
                let URL = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/GuardarDocumentoElectronico';
                let GestorEnviar = {
                    ...Gestor,
                    DetalleLineas: Gestor.DetalleLineas.map((item, index) => ({
                        ...item,
                        LineId: index + 1
                    })),
                    NombreCliente: (Gestor.TipoDocumento === '4' || Gestor.TipoDocumento === '9') && Gestor.SN === 'S' ? Gestor.Nombre ? Gestor.Nombre : 'Cliente Contado' : Gestor.NombreCliente,
                    CedulaCliente: (Gestor.TipoDocumento === '4' || Gestor.TipoDocumento === '9') && Gestor.SN === 'S' ? '101230123' : Gestor.CedulaCliente,
                    MedioPago: mediosPago,
                    TipoDocumento: Gestor.TipoDocumento === 'C' && DocumentosReferenciados.length > 0 ? '1' : Gestor.TipoDocumento,
                    TipoDocRef: TipoDocRef,
                    CondicionVentaText: Gestor.CondicionVenta === '02' || Gestor.CondicionVenta === '10' ? '4.4' : Gestor.CondicionVentaText,
                    PlazoCredito: Gestor.CondicionVenta === '02' || Gestor.CondicionVenta === '10' ? (Math.ceil((new Date(Gestor.Vencimiento) - new Date(Gestor.DocDate)) / (1000 * 60 * 60 * 24))).toString() : Gestor.PlazoCredito,
                };
                console.log(JSON.stringify(GestorEnviar));
                await fetch(URL, EncabezadoPost(Token, GestorEnviar)).then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json.errors) {
                            let errorMessages = Object.values(json.errors).flat().join(', ');
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: errorMessages,
                            });
                            return;
                        }
                        if (json.CodRespuesta === 'Accepted' || json.Informacion === 'Alerta al generar token Unauthorized') {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Documento Guardado. Consecutivo: ' + json.Consecutivo,
                                showConfirmButton: true,
                                html: `
                                    <div>
                                        <button id="printButton" class="swal2-confirm swal2-styled" style="margin: 5px;">Imprimir</button>
                                        <button id="downloadPdfButton" class="swal2-confirm swal2-styled" style="margin: 5px;">Descargar PDF</button>
                                        <button id="documentsButton" class="swal2-confirm swal2-styled" style="margin: 5px;">Ir a Documentos</button>
                                        <div style="margin-top: 10px;">
                                            <input type="checkbox" id="ticketCheckbox" />
                                            <label for="ticketCheckbox">Tipo Tiquete</label>
                                        </div>
                                    </div>
                                `,
                                didOpen: () => {
                                    document.getElementById('printButton').addEventListener('click', () => ImpresionDocumentos(json.NumDoc, 'IMP'));
                                    document.getElementById('downloadPdfButton').addEventListener('click', () => ImpresionDocumentos(json.NumDoc, 'PDF'));
                                    document.getElementById('documentsButton').addEventListener('click', RedireccionarDocumentos);
                                },
                                allowOutsideClick: true,
                                allowEscapeKey: true
                            });
                            //navigate("/Clientes/GeneralCliente");
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: json.Informacion
                            })
                        }
                    })
            }
        });
    }
    const [MisActividades, setMisActividades] = useState([{}]);
    const [ActividadesCliente, setActividadesCliente] = useState([{}]);

    const [PlanActivo, setPlanActivo] = useState(true);

    const [MisClientes, setMisClientes] = useState([{}]);
    const [ListaSocios, setSocio] = useState([{}])
    const [selectedOption, setSelectedOption] = useState(null);
    const handleChange = (selectedOption) => {
        console.log(selectedOption);
        setSelectedOption(selectedOption);

        //setGestor({ ...Gestor, "CedulaCliente": selectedOption.value });
        const cliente = MisClientes.find(item => item.FAC_CED_CLI === selectedOption.value);
        if (cliente) {
            //console.log(cliente)
            setGestor(prevState => ({
                ...prevState,
                CedulaCliente: selectedOption.value,
                NombreCliente: cliente.FAC_NOMBRE,
                CorreoCliente: cliente.FAC_CORREO,
                TipoIdentCliente: cliente.FAC_TIPO_CL.toString(),
                SenasCliente: cliente.OTRAS_DIRECCIONES,
                ProvinciaCliente: cliente.PROVINCIA,
                CantonCliente: cliente.CANTON.toString(),
                DistritoCliente: cliente.DISTRITO.toString(),
                EsClienteExonerado: cliente.TIPO_TRIBUTARIO === 0,
                cboTipoDocExoneracion: cliente.ETipoDoc,
                txtNumeroDocumentoExonera: cliente.ENumDoc,
                txtNombreInstiExonera: '01', //cliente.Einstitucion,
                cboPorcentajeExoneracion: cliente.EPorcentaje,
                txtFechaEmisionExonera: new Date(cliente.EFechaEmision).toISOString().split('T')[0],
                Articulo: cliente.Articulo.toString(),
                Inciso: cliente.Inciso.toString(),
                DE_TASA_IMP: cliente.DE_TASA_IMP
            }));
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Este cliente no existe, valide si lo creo en otro sistema (valide que exista), en tal efecto debe crearlo para hacer el documento correspondiente',
            });
        }
    };

    const [productos, setProductos] = useState([{}]);
    const [comboArts, setcomboArts] = useState([{}]);
    const [ProductoSeleccionado, setProductoSeleccionado] = useState(null);
    const handleChangeArts = (selectedOption) => {
        setProductoSeleccionado(selectedOption);
        // console.log(selectedOption)
        setGestor({ ...Gestor, "ProductoAgregar": selectedOption.value });
        const producto = productos.find(item => item.DE_CODIGO_ART === selectedOption.value);
        if (producto) {

            document.getElementById('price').value = producto.DE_PRECIO;
            document.getElementById('quantity').value = 1;
            document.getElementById('discount').value = 0;
        }
    };

    const [DocumentosReferenciados, setDocumentosReferenciados] = useState([{}]);

    const CargaDocumentoReferenciados = async (TipoDoc, TipoRef) => {
        let URL = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/ComboReferencias?IdCia=' + PerfilUsuario.IdCia + '&TipoDoc=' + TipoDoc + '&TipoRef=' + TipoRef;
        //console.log(URL);
        await fetch(URL, EncApi(Token)
        ).then(response => response.json())
            .then(async json => {
                console.log(json);
                setDocumentosReferenciados(json.Contenido);
                if (json.Contenido && json.Contenido.length > 0) {
                    await Oriflar(TipoRef, json.Contenido[0].Codigo);
                }
            })
    };

    const Oriflar = async (TipoDoc, NomDoc) => {
        let URL = 'https://smartfecr.com:2020/SmartContrackBack/api/DocumentosElectronicos/Oriflar?IdCia=' + PerfilUsuario.IdCia + '&TipoDoc=' + TipoDoc + '&DocNum=' + NomDoc;
        console.log(URL);
        await fetch(URL, EncApi(Token)
        ).then(response => response.json())
            .then(json => {
                console.log(json);
                const detalleLineas = json.Contenido.Detalle.map(item => ({
                    ...item,
                    Price: item.PrecioUnitario,
                    Articulo: item.DetalleAdicional ? item.DetalleAdicional : '0',
                    Inciso: item.IndicadorIvaSAP ? item.IndicadorIvaSAP : '0',
                    SujetoImpuesto: item.SujetoImpuesto === 'True',
                    AplicaExonera: item.AplicaExonera === 'True'
                }));
                const totalMontoCargo = json.Contenido.Detalle.reduce((acc, item) => acc + (item.MontoCargo > 0 ? item.MontoCargo : 0), 0);
                setGestor(prevState => ({
                    ...prevState,
                    DetalleLineas: detalleLineas,
                    NumeroRef: json.Contenido.Encabezado.Clave,
                    FechaEmisionRef: json.Contenido.Encabezado.Fecha,
                    CargosAdicionales: totalMontoCargo > 0 ? [{ TipoDocumentoOC: '06', Detalle: 'Servicio restaurante', MontoCargo: totalMontoCargo }] : null
                }));
                handleChange({ value: json.Contenido.Encabezado.Cedula, label: json.Contenido.Encabezado.Nombre });
            });
    };

    const AgregarDetalleLinea = () => {
        const price = parseFloat(document.getElementById('price').value);
        if (price < 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'El precio debe ser mayor o igual a cero',
            });
            return;
        }

        const quantity = parseFloat(document.getElementById('quantity').value);
        if (quantity <= 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'La cantidad debe ser mayor a cero',
            });
            return;
        }

        const producto = productos.find(item => item.DE_CODIGO_ART === Gestor.ProductoAgregar);

        const PorcExonera = Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? parseFloat(Gestor.cboPorcentajeExoneracion) : 0;

        if (producto) {

            let discount = 0;
            if (document.getElementById('CkDescMonto').checked) {
                if (producto.DE_PRECIO_IVI === "S") {
                    console.log('Descuento IVA');
                    let PrecTempDesc = price / (1 + (parseFloat(producto.DE_TASA_IMP) / 100));
                    console.log(PrecTempDesc);
                    let DescAnt = parseFloat(document.getElementById('discount').value) / (1 + (parseFloat(producto.DE_TASA_IMP) / 100));
                    discount = (1 - ((PrecTempDesc - DescAnt) / PrecTempDesc)) * 100;
                }
                else {

                    discount = (1 - ((price - parseFloat(document.getElementById('discount').value)) / price)) * 100;
                }
            }
            else {
                discount = parseFloat(document.getElementById('discount').value);
            }

            if (discount < 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'El descuento debe ser mayor o igual a cero',
                });
                return
            }

            let Precio = producto.DE_PRECIO_IVI === "N" ? price : (price / (1 + (parseFloat(producto.DE_TASA_IMP) || 0) / 100))
            if (producto.DE_CODIGO_TARIFA !== Gestor.DE_TASA_IMP) {
                const idx = CodigosTarifasDiferenciadas.findIndex(
                    item => item.value === Gestor.DE_TASA_IMP
                );
                if (idx !== -1) {

                    const tarifaObj = CodigosTarifasDiferenciadas[idx];
                    // Si producto.DE_TASA_IMP > tarifaObj.Tarifa, actualiza los valores
                    if (parseFloat(producto.DE_TASA_IMP) > parseFloat(tarifaObj.Tarifa)) {

                        producto.DE_CODIGO_TARIFA = tarifaObj.value;
                        producto.DE_TASA_IMP = tarifaObj.Tarifa;
                    }
                }
            }
            const unidadMedida = LasUnidadesMedida.find(item => item.CODIGO === producto.DE_UNIDAD_MEDIDA)?.SIMBOLO || '';
            console.log(Precio);
            let ProdAgrega = {
                ItemCode: producto.DE_CODIGO_ART,
                Detalle: producto.DE_NOMBRE_ART,
                Cantidad: quantity,
                PrecioUnitario: Precio,
                Tarifa: producto.DE_TASA_IMP,
                TotalComprobante: (Precio * (1 - (discount / 100))) * (1 + ((producto.DE_TASA_IMP - PorcExonera) / 100)) * quantity,
                PorcentajeDescuento: discount,
                IVI: producto.DE_PRECIO_IVI,
                Price: price,
                AplicaExonera: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado,
                TipoDocExoneracion: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? Gestor.cboTipoDocExoneracion : '01',
                NumeroDocumentoExonera: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? Gestor.txtNumeroDocumentoExonera : '',
                NombreInstiExonera: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? Gestor.txtNombreInstiExonera : '01',
                PorcentajeExoneracion: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? Gestor.cboPorcentajeExoneracion : 0,
                FechaEmisionExonera: Gestor.cboAplicaExonera === 'S' && Gestor.EsClienteExonerado ? Gestor.txtFechaEmisionExonera : Gestor.DocDate,
                Articulo: Gestor.cboTipoDocExoneracion === '02' || Gestor.cboTipoDocExoneracion === '03' || Gestor.cboTipoDocExoneracion === '06' || Gestor.cboTipoDocExoneracion === '07' || Gestor.cboTipoDocExoneracion === '08' ? Gestor.Articulo : '0',
                Inciso: Gestor.cboTipoDocExoneracion === '02' || Gestor.cboTipoDocExoneracion === '03' || Gestor.cboTipoDocExoneracion === '06' || Gestor.cboTipoDocExoneracion === '07' || Gestor.cboTipoDocExoneracion === '08' ? Gestor.Inciso : '0',
                CABYS: producto.CABYS,
                NumeroVINoSerie: '',
                RegistroMedicamento: producto.RegistroMedicamento,
                FormaFarmaceutica: producto.FormaFarmaceutica,
                BaseImponible: 0,
                SujetoImpuesto: producto.DE_CODIGO_TARIFA === '10',
                ArtServ: producto.DE_TIPO_ARTICULO === 0 ? "S" : "A",
                UnidadMedida: unidadMedida,
                CodigoImpuesto: producto.DE_CODIGO_IMPUESTO,
                CodigoTarifa: producto.DE_CODIGO_TARIFA,
                CargosAdicionales: Gestor.ImpServ === 'S' ? [{ TipoDocumentoOC: '06', Detalle: 'Servicio restaurante', MontoCargo: (producto.DE_PRECIO_IVI === "N" ? price : price / (1 + (parseFloat(producto.DE_TASA_IMP) || 0) / 100)) * 0.1 }] : null,
                PartidaArancelaria: producto.PartidaArancelaria,
                CodigoComercial: producto.DE_CODIGO_ART,
                MontoExportacion: 0,
                IndicadorIvaSAP: '',
                Almacen: ''
            }
            setGestor(prevState => ({
                ...prevState,
                DetalleLineas: [...prevState.DetalleLineas, ProdAgrega]
            }));
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No ha seleccionado un producto válido',
            });
        }
    };

    const Totalizar = (origen) => {
        // console.log(Gestor.DetalleLineas);
        const total = Gestor.DetalleLineas.reduce((acc, item) => acc + (((item.PrecioUnitario * (1 - (item.PorcentajeDescuento / 100))) * (1 + ((Gestor.ImpServ === "N" && origen === 'ck') || (Gestor.ImpServ === 'S' && origen === 'Efec') ? 0.1 : 0) + ((item.Tarifa - (item.AplicaExonera ? item.PorcentajeExoneracion : 0)) / 100))) * item.Cantidad), 0);
        const montoOtros = Math.round(Gestor.DetalleLineas.reduce((acc, item) => acc + (((item.PrecioUnitario * (1 - (item.PorcentajeDescuento / 100))) * (((Gestor.ImpServ === "N" && origen === 'ck') || (Gestor.ImpServ === 'S' && origen === 'Efec') ? 0.1 : 0))) * item.Cantidad), 0));
        setGestor(prevState => ({
            ...prevState,
            TotalSap: total,
            TieneOtrosCargos: (Gestor.ImpServ === "N" && origen === 'ck') || (Gestor.ImpServ === 'S' && origen === 'Efec'),
            CargosAdicionales: ((Gestor.ImpServ === "N" && origen === 'ck') || (Gestor.ImpServ === 'S' && origen === 'Efec')) && montoOtros > 0 ? [{ TipoDocumentoOC: '06', Detalle: 'Servicio restaurante', MontoCargo: montoOtros }] : null,
        }));
    }

    const ActualizarDetalleLinea = (indice, price, descuento, cantidad, vinSerie) => {

        setGestor(prevState => {
            const updatedDetalleLineas = prevState.DetalleLineas.map((item, index) => {
                if (index === indice) {
                    return {
                        ...item,
                        PrecioUnitario: item.IVI === "N" ? price : price / (1 + (parseFloat(item.Tarifa) || 0) / 100),
                        PorcentajeDescuento: descuento,
                        Cantidad: cantidad,
                        Price: price,
                        NumeroVINoSerie: vinSerie,
                        TotalComprobante: ((item.IVI === "N" ? price : price / (1 + (parseFloat(item.Tarifa) || 0) / 100)) * (1 - (descuento / 100))) * (1 + (item.Tarifa / 100)) * cantidad
                    };
                }
                return item;
            });
            return {
                ...prevState,
                DetalleLineas: updatedDetalleLineas
            };
        });
    };

    const EliminarDetalleLinea = (indice) => {
        setGestor(prevState => ({
            ...prevState,
            DetalleLineas: prevState.DetalleLineas.filter((_, index) => index !== indice)
        }));
    };

    /*
    const CargandoDocumentoNuevo = async () => {
        await fetch('https://smartfecr.com:2020/SmartContrackBack/api/Socios/BusquedaCliente?IdCia=' + Rol.IdCia + '&Criterio='
        ).then(response => response.json())
            .then(json => {
                const lista = json.map(item => ({
                    value: item.FAC_CED_CLI,
                    label: item.FAC_NOMBRE + ' ' + item.FAC_CED_CLI
                }));
                setSocio(lista);
            })

    };
    */

    const CargandoDocumentoNuevo = async () => {
        console.log('https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/CargandoDocumentoNuevo?IdCia=' + PerfilUsuario.IdCia)
        await fetch('https://smartfecr.com:2020/SmartContrackBack/api/SmartFeCr/CargandoDocumentoNuevo?IdCia=' + PerfilUsuario.IdCia, EncApi(Token)
        ).then(response => response.json())
            .then(json => {

                //Productoa
                const lista = json.Productos.map(item => ({
                    value: item.DE_CODIGO_ART,
                    label: item.DE_NOMBRE_ART + '-' + item.DE_CODIGO_ART
                }));
                setcomboArts(lista);
                setProductos(json.Productos);

                // console.log(json);
                //Clientes
                const listaClientes = json.Clientes.map(item => ({
                    value: item.FAC_CED_CLI,
                    label: item.FAC_NOMBRE + ' ' + item.FAC_CED_CLI
                }));
                setSocio(listaClientes);
                setMisActividades(json.Actividades);
                setMisClientes(json.Clientes);
                setActividadesCliente(json.ActividadesCliente);

                setGestor(prevState => ({
                    ...prevState,
                    DocDate: json.FechaServidor,
                    FechaEmisionRef: json.FechaServidor,
                    Vencimiento: new Date(new Date(json.FechaServidor).setDate(new Date(json.FechaServidor).getDate() + 30)).toISOString().split('T')[0],
                    TC: json.TC.monto,
                    BDCompania: PerfilUsuario.BD,
                    Ambiente: PerfilUsuario.IdCia !== 1,
                    CodigoActividad: json.Actividades[0].CodigoActividad,
                }));

                console.log(PerfilUsuario.IdCia !== 1);
                setLasUnidadesMedida(json.UnidadesMedida);

                if (json.Plan === "D") {
                    if (json.VerificaPaquete[0].Puede === "NO") {
                        setPlanActivo(false);
                        Swal.fire({
                            icon: 'warning',
                            title: 'Activación de Plan',
                            text: json.VerificaPaquete[0].Razon,
                        });
                    }
                    else {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Resumen de Plan',
                            text: json.VerificaPaquete[0].Razon,
                        });
                    }

                }
            })

    };


    const RedireccionarDocumentos = () => {
        Swal.close();
        console.log(Gestor.TipoDocumento);
        switch (Gestor.TipoDocumento) {
            case '1':
                navigate("/Documentos/Facturas");
                break;
            case '2':
                navigate("/Documentos/NDs");
                break;
            case '3':
                navigate("/Documentos/NCs");
                break;
            case '4':
                navigate("/Documentos/Tiquetes");
                break;
            case '8':
                navigate("/Documentos/FECs");
                break;
            case '9':
                navigate("/Documentos/Exportacion");
                break;
            case '10':
                navigate("/Documentos/RecibosPago");
                break;
            case 'C':
                navigate("/Documentos/Cotizaciones");
                break;
            default:
                break;
        }
    }

    const ImpresionDocumentos = async (NumDoc, ModoApertura) => {
        const Doc = (TiposDocsCrearDoc.find(item => item.value === Gestor.TipoDocumento)?.Con || '') + (document.getElementById('ticketCheckbox').checked ? '-PV' : '');
        const url = 'https://smartfecr.com:2017/api/Reportes/GeneraDocumento?NumDoc=' + NumDoc + '&Doc=' + Doc + '&IdCia=' + PerfilUsuario.IdCia;
        console.log(url);
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (ModoApertura === 'PDF') {
                const tempLink = document.createElement('a');
                tempLink.href = `data:application/pdf;base64,${data.Result}`;
                tempLink.setAttribute('download', 'Documento ' + NumDoc + '.pdf');
                tempLink.click();
            }
            else {
                const blob = new Blob([Uint8Array.from(atob(data.Result), c => c.charCodeAt(0))], { type: "application/pdf" });
                const objectURL = URL.createObjectURL(blob);

                const iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = objectURL;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                };

            }


        } catch (error) {
            console.error("Error fetching document lines:", error);
        }
    }




    const navigate = useNavigate();
    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const Salir = () => {
        navigate("/");
    }
    useEffect(() => {
        if (PerfilUsuario) {
            CargandoDocumentoNuevo();
        }


        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        console.log(Gestor.CedulaCliente);
        const actividadCliente = ActividadesCliente.find(item => item.FAC_CED_CLI === Gestor.CedulaCliente);
        if (actividadCliente) {
            setGestor(prevState => ({
                ...prevState,
                CodigoActividadReceptor: actividadCliente.CODIGO_ACTIVIDAD
            }));
        }
        else {
            setGestor(prevState => ({
                ...prevState,
                CodigoActividadReceptor: ''
            }));
        }
    }, [Gestor.CedulaCliente, ActividadesCliente]);

    useEffect(() => {
        Totalizar('Efec');
        // eslint-disable-next-line
    }, [Gestor.DetalleLineas]);

    if (PerfilUsuario && LasUnidadesMedida && Token) {
        return (
            <div className='main-block'>
                <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                    <div className='formadoShadow'>

                        <div className='tituloPantalla'>
                            <p style={{ display: 'inline-block' }}> Creación Documento Electrónico</p>
                            <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                        </div>
                        <div className="row">
                            <div className="col-25">
                                <button hidden={!PlanActivo} id="Guardar" onClick={() => GuardarDocumento()} name="Guardar" style={{ fontSize: '12px', padding: '5px', maxWidth: '90px' }}>
                                    <i className="fa fa-save"></i> Guardar
                                </button>
                            </div>
                            <div className='col-75'></div>
                        </div>
                        <Encabezado
                            Modificar={Modificar}
                            Gestor={Gestor}
                            PerfilUsuario={PerfilUsuario}
                            handleChange={handleChange}
                            ListaSocios={ListaSocios}
                            MisActividades={MisActividades}
                            DocumentosReferenciados={DocumentosReferenciados}
                            ActividadesCliente={ActividadesCliente}

                            selectedOption={selectedOption} />
                        <AgregarProd
                            ProductoSeleccionado={ProductoSeleccionado}
                            handleChangeArts={handleChangeArts}
                            comboArts={comboArts}
                            Modificar={Modificar}
                            Gestor={Gestor}
                            AgregarDetalleLinea={AgregarDetalleLinea} />
                        <TablaProductos Gestor={Gestor}
                            EliminarDetalleLinea={EliminarDetalleLinea}
                            ActualizarDetalleLinea={ActualizarDetalleLinea}
                        />
                        <PieDelDocumento Modificar={Modificar} Gestor={Gestor} />
                    </div>
                </div>
            </div>

        );
    }
    else {

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f9f9f9',
                fontFamily: 'Arial, sans-serif',
                color: '#555',
                textAlign: 'center'
            }}>
                <div>
                    <p style={{
                        fontSize: '18px',
                        marginBottom: '10px'
                    }}>Cargando Documento...</p>
                    <p style={{
                        fontSize: '14px',
                        color: '#888'
                    }}>Por favor, espere mientras se cargan los datos necesarios.</p>
                </div>
            </div>
        );

    }
};

export default BaseDoc;